var _style, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCE868;}\n\t.st1{fill:none;stroke:#FCE868;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{fill:#2B353F;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 500,
    cy: 500,
    r: 500
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M566.2,432.2c-17.3-29.9-55.6-40.2-85.5-22.9l-103.3,59.6l58.8,101.8c17.3,29.9,55.6,40.2,85.5,22.9L625,534 L566.2,432.2z M513.6,548c-16.4,9.5-37.4,3.8-46.8-12.6l-29.3-50.7l51.5-29.7c16.4-9.5,37.4-3.8,46.8,12.6l29.3,50.7L513.6,548z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M880,500c0-180-125.5-330.6-293.8-369.2v0c0,28.4,16.9,54.3,43.1,65.4C738.7,242.4,818,346.1,829.3,469.4 c-24.9-11.4-58.3-21.9-97.2-21.9c-9.4,0-19.1,0.6-29.1,2c-15.1,2.1-24.7,17.2-20.8,31.9c3.4,12.5,15.5,20.2,28.3,18.5 c53.6-7.1,97.1,13.7,118.6,27v110.7c0,14.1,11.4,25.5,25.5,25.5c14.1,0,25.5-11.4,25.5-25.5V503.2L880,500z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120,500c0,180,125.5,330.6,293.8,369.2v0c0-28.4-16.9-54.3-43.1-65.4C261.3,757.6,182,653.9,170.7,530.6 c24.9,11.4,58.3,21.9,97.2,21.9c9.4,0,19.1-0.6,29.1-2c15.1-2.1,24.7-17.2,20.8-31.9c-3.4-12.5-15.5-20.2-28.3-18.5 c-53.6,7.1-97.1-13.7-118.6-27V362.4c0-14.1-11.4-25.5-25.5-25.5c-14.1,0-25.5,11.4-25.5,25.5v134.4L120,500z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d33591c4e9bc9bf9e587d5e422b2cf70.svg";
export { ForwardRef as ReactComponent };